// extracted by mini-css-extract-plugin
export var comment = "commentForm-module--comment--bf495";
export var email = "commentForm-module--email--bd4d8";
export var error = "commentForm-module--error--f8901";
export var form = "commentForm-module--form--dc1fc";
export var label = "commentForm-module--label--7180c";
export var name = "commentForm-module--name--dadc5";
export var ratingText = "commentForm-module--rating-text--f4583";
export var status = "commentForm-module--status--6c476";
export var submit = "commentForm-module--submit--74ec9";